// MARK://dhk8/pos/lib/queries/printing
// Queries tipadas de impresión — F3.4 (stations) + F4.3 (templates/jobs) / ADR-0009.
// El POS lee impresión por el grafo (pos-printing, tenant del JWT). Escrituras
// (crear/editar plantilla, enqueue/reprint/status, estaciones) siguen REST. Campos
// inline (el preset `client` de codegen NO evalúa interpolaciones en el tag `graphql`).
import { graphql } from '../../gql/index.js'

export const PosPrintStationsQuery = graphql(`
  query PosPrintStations($branchId: String) {
    printStations(branchId: $branchId) { id tenantId branchId name sortOrder }
  }
`);

export const PosPrintTemplatesQuery = graphql(`
  query PosPrintTemplates($branchId: String, $kind: String, $page: Int, $limit: Int) {
    printTemplates(branchId: $branchId, kind: $kind, page: $page, limit: $limit) {
      total
      page
      limit
      items { id tenantId branchId kind name body active createdAt updatedAt }
    }
  }
`);

export const PosPrintJobsQuery = graphql(`
  query PosPrintJobs($branchId: String, $terminalId: String, $status: String, $page: Int, $limit: Int) {
    printJobs(branchId: $branchId, terminalId: $terminalId, status: $status, page: $page, limit: $limit) {
      total
      page
      limit
      items { id tenantId branchId terminalId printerId templateId kind payload rendered status attempts lastError createdAt updatedAt }
    }
  }
`);


// ── F6.2 R1 / ADR-0008: lecturas singulares por el grafo (tenant del JWT, IDOR-guard) ──
export const PosPrintTemplateQuery = graphql(`
  query PosPrintTemplate($id: ID!) {
    printTemplate(id: $id) { id tenantId branchId kind name body active createdAt updatedAt }
  }
`);

export const PosPrintJobByIdQuery = graphql(`
  query PosPrintJobById($id: ID!) {
    printJobById(id: $id) { id tenantId branchId terminalId printerId templateId kind payload rendered status attempts lastError createdAt updatedAt }
  }
`);

// ── F8.1 / ADR-0009: escrituras de impresion por el grafo (mutations, tenant del JWT) ──
export const PosCreatePrintTemplateMutation = graphql(`
  mutation PosCreatePrintTemplate($input: PosPrintingCreateTemplateInput!) {
    createPrintTemplate(input: $input) { id tenantId branchId kind name body active createdAt updatedAt }
  }
`);

export const PosUpdatePrintTemplateMutation = graphql(`
  mutation PosUpdatePrintTemplate($id: ID!, $input: PosPrintingUpdateTemplateInput!) {
    updatePrintTemplate(id: $id, input: $input) { id tenantId branchId kind name body active createdAt updatedAt }
  }
`);

export const PosDeletePrintTemplateMutation = graphql(`
  mutation PosDeletePrintTemplate($id: ID!) { deletePrintTemplate(id: $id) }
`);

export const PosEnqueuePrintJobMutation = graphql(`
  mutation PosEnqueuePrintJob($input: PosPrintingEnqueueJobInput!) {
    enqueuePrintJob(input: $input) { id tenantId branchId terminalId printerId templateId kind payload rendered status attempts lastError createdAt updatedAt }
  }
`);

export const PosReprintPrintJobMutation = graphql(`
  mutation PosReprintPrintJob($sourceJobId: ID!, $input: PosPrintingReprintJobInput) {
    reprintPrintJob(sourceJobId: $sourceJobId, input: $input) { id tenantId branchId terminalId printerId templateId kind payload rendered status attempts lastError createdAt updatedAt }
  }
`);

export const PosUpdatePrintJobStatusMutation = graphql(`
  mutation PosUpdatePrintJobStatus($id: ID!, $input: PosPrintingUpdateJobStatusInput!) {
    updatePrintJobStatus(id: $id, input: $input) { id tenantId branchId terminalId printerId templateId kind payload rendered status attempts lastError createdAt updatedAt }
  }
`);
